/**
 * C1 F28: A CREATION RULE AND A SIGN-IN CHECK ARE DIFFERENT QUESTIONS, AND
 * SHARING ONE TYPE BETWEEN THEM LOCKED A WHOLE ROSTER OUT.
 *
 * `password` is the rule for a password being FORMED: signup and the admin
 * sign-up page run it, and an uppercase character plus a digit or symbol is a
 * reasonable thing to ask of a value that does not exist yet.
 *
 * `existingPassword` is the check for a password being TYPED BACK. It asks only
 * that something was typed, because the value was already set, by whatever rule
 * applied then, and the only authority on whether it is the right one is the
 * server. The platform's own roster upload generates twelve lowercase letters
 * and digits on purpose (the value is read aloud to a room and typed on a
 * phone, so look-alike and shifted characters are excluded), and the login form
 * running the CREATION rule over it refused every one of those learners with no
 * request and no error text on screen.
 */
export function validateFormField(value, type) {
  if (!value) {
    if (type === "radio") return "Please select one of this radio";
    return "Please input value";
  }
  if (type === "existingPassword") {
    /* Non-empty is the whole check, and the guard above already made it. The
       branch is NAMED rather than left to the fall-through below, so that the
       login form's rule is something this module states and not something it
       happens to do with a type it does not recognise. */
    return "";
  }
  if (type === "password") {
    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumberOrSymbol = /[\d\W]/.test(value);
    if (value.length < 8) {
      return "The password must be at least 8 characters.";
    }
    if (hasUpperCase && hasNumberOrSymbol) return "";
    return "You have entered an invalid email or password";
  } else if (type === "email") {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return "Input correct Email.";
    }
  } else if (type === "fullname") {
    const fullname = value.split(" ");
    if (fullname.length !== 2)
      return "The fullname should combination of first name and last name";
  } else if (type === "bLink") {
    if (!/^(ftp|http|https):\/\/[^ "]+$/.test(value))
      return "This is not valid link.";
  } else if (type === "description") {
    if (value.length < 10) return "Please enter at least 10 characters.";
  }
  return "";
}
